import { defineMeta } from '@/registry/types';

export const accordionMeta = defineMeta({
  name: 'Accordion',
  level: 'organism',
  category: 'surface',
  classification: 'themed-mui',
  description: 'Expandable sections for progressive disclosure. Themed MUI Accordion.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Accordion',
  muiDocs: 'https://mui.com/material-ui/react-accordion/',
  a2uiEquivalent: 'Accordion',
  importPath: '@/organisms/Accordion',
  optionalProps: ['expanded', 'defaultExpanded', 'disabled', 'onChange'],
  supportedStates: ['collapsed', 'expanded', 'disabled'],
  designTokens: ['colors', 'radius', 'typography'],
  accessibility: ['Summary is a button controlling the region; keyboard operable.'],
  usageExamples: [
    '<Accordion><AccordionSummary><Typography variant="subtitle1">Evidence</Typography></AccordionSummary><AccordionDetails><Typography variant="body1">...</Typography></AccordionDetails></Accordion>',
  ],
  rules: [
    'Summary text is `Typography variant="subtitle1"`; detail copy is `variant="body1"`.',
  ],
  antiPatterns: ['Do not hide critical content behind accordions by default.'],
  mountsSurface: 'inline',
  llmSafe: true,
  whenToUse: ['Long detail pages, grouped settings'],
  whenNotToUse: ['Primary navigation'],
});

export default accordionMeta;
